import React, { useState } from 'react';
import * as Icon from 'react-feather';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';

const sections = [
  { id: 'basic', label: 'Basic Info', icon: Icon.User },
  { id: 'context', label: 'Context Breakdown', icon: Icon.FileText },
  { id: 'transcriber', label: 'Transcriber', icon: Icon.Mic },
  { id: 'model', label: 'AI Model', icon: Icon.Cpu },
  { id: 'voice', label: 'Voice Configuration', icon: Icon.Volume2 },
  { id: 'websearch', label: 'Web Search', icon: Icon.Search },
  // { id: 'email', label: 'Post Call Email', icon: Icon.Mail },
  { id: 'webhook', label: 'Webhook', icon: Icon.Link },
  { id: 'filler', label: 'Filler', icon: Icon.MessageCircle },
  { id: 'transfer', label: 'Call Transfer', icon: Icon.PhoneForwarded }
];

const AIAgentSettingsPage = ({ handleSubmit, children, validateForm }) => {
  const [active, setActive] = useState('basic');

  const activeSection = sections.find((s) => s.id === active);
  const ActiveIcon = activeSection?.icon;

  const findErrorSection = (errors) => {
    if (errors.name || errors.welcome_message || errors.call_type) return 'basic';
    if (errors.context_breakdown) return 'context';
    if (errors.transcriber) return 'transcriber';
    if (errors.model) return 'model';
    if (errors.voice) return 'voice';
    if (errors.web_search) return 'websearch';
    if (errors.post_call_actions?.email) return 'email';
    if (errors.post_call_actions?.webhook) return 'webhook';
    if (errors.filler) return 'filler';
    if (errors.transfer) return 'transfer';

    return null;
  };

  return (
    <div className="ai-settings-page">
      <div className="settings-layout">
        <div className="settings-sidebar">
          {sections.map((section) => {
            const IconComponent = section.icon;
            return (
              <div
                key={section.id}
                className={`sidebar-item ${active === section.id ? 'active' : ''}`}
                onClick={() => setActive(section.id)}>
                <IconComponent size={16} />
                <span>{section.label}</span>
              </div>
            );
          })}
        </div>

        <div className="settings-content">
          {/* HEADER */}
          <div className="settings-header">
            {ActiveIcon && <ActiveIcon size={16} />}
            <h6>{activeSection?.label}</h6>
          </div>

          {/* FORM CONTENT */}
          <form
            onSubmit={async (e) => {
              e.preventDefault();
              const formErrors = await validateForm();
              if (Object.keys(formErrors).length > 0) {
                const errorTab = findErrorSection(formErrors);
                if (errorTab) {
                  setActive(errorTab);
                  toast.error('Please complete all required fields.');
                }
              }
              handleSubmit();
            }}
            id="ai-agent-form">
            {React.Children.map(children, (child) => (child?.props?.id === active ? child : null))}
          </form>
        </div>
      </div>
    </div>
  );
};

AIAgentSettingsPage.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  children: PropTypes.node,
  validateForm: PropTypes.any
};

export default AIAgentSettingsPage;
